import React from 'react'

let ControllerLastUpdatedPanel = ({controller}) =>
        <div className="col-12 align-items-center pt-2 pb-1 bg-muted-sf-orange">
            <small className="text-muted col-12 col-md-6 p-0 d-inline-block text-center text-md-right">
                Last&nbsp;Updated&nbsp;
                {controller.lastUpdatedGMT ?
                    controller.lastUpdatedTimeString:
                    null}&nbsp;
                {controller.lastUpdatedGMT ?
                    controller.lastUpdatedDateString:
                    "Never"}
            </small>
            <small className="text-muted col-1 d-none d-md-inline-block">
                &emsp;|&emsp;
            </small>
            <small className="col-12 col-md-5 text-muted p-0 d-inline-block text-center text-md-left">
                Local&nbsp;Time&nbsp;
                {controller.localDateTime ?
                    controller.localTimeString:
                    null}&nbsp;
                {controller.localDateTime ?
                    controller.localDateString:
                    "Unknown"}
            </small>
        </div>

export default ControllerLastUpdatedPanel


// WEBPACK FOOTER //
// ./src/components/ui/ControllerLastUpdatedPanel.js